// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__14xuZ","title":"Images90_title__3ZvCD","images":"Images90_images__1GzAm"};